// No-plan accounts (user.isPlanRequired): the example project is readable, every creation action
// opens the "Run this on your own pages" modal instead of running. Component-level gating uses
// requirePlan(); the router guard and the API interceptor (action PLAN_REQUIRED) are the backstops.
export const PLAN_LOCKED_ROUTES = [
  'NewSite', 'NewPage', 'RerunAnalysis', 'NewBulkRun', 'custom-silo-create', 'one-click-silo-create',
]

export function showPlanRequired (store, reason = '') {
  store.commit('showPlanRequiredModal', { reason })
}

export const planGateMixin = {
  computed: {
    isNoPlanUser () {
      return Boolean(this.$store.getters.isNoPlanUser)
    },
  },
  methods: {
    /** Runs fn for accounts with a plan; opens the lock modal (and returns false) otherwise. */
    requirePlan (fn, reason = '') {
      if (this.$store.getters.isNoPlanUser) {
        showPlanRequired(this.$store, reason)
        return false
      }
      if (typeof fn === 'function') fn()
      return true
    },
  },
}
